function getElementHeight(selector) {
  const element = document.querySelector(selector);
  return element?.clientHeight ?? 0;
}

export default getElementHeight;
